/**
 * Domain Entity: UserContext
 * Represents user-specific context needed by the UI (header, menus, etc).
 *
 * This is intentionally smaller/cleaner than the API response.
 */
export class UserContext {
  isLoggedIn: boolean;
  isSoftLoggedIn: boolean;
  softLoginId?: string;
  softLoginType?: string;
  userName?: string;
  /**
   * Backend-provided anonymous visitor identifier.
   * Used as a stable key for A/B bucketing + allocation tracking.
   */
  visitorId?: number;
  /**
   * Legacy alias kept for UI compatibility.
   * Backend uses `customerName`; our domain uses `userName`.
   */
  customerName?: string;
  cartCount: number;
  wishlistCount: number;
  videoCallTahItemsCount: number;
  maxVideoCallCount: number;
  maxCartItemsCount: number;
  videoCallCartMessage?: string;

  accountMergingPopupEnabled?: boolean;
  primaryAccountSet?: boolean;
  phoneNumberVerified?: boolean;
  hasPhoneNumber?: boolean;
  pincode?: string;
  guessedPincode?: boolean;

  constructor({
    isLoggedIn,
    isSoftLoggedIn = false,
    softLoginId,
    softLoginType,
    userName,
    visitorId,
    cartCount,
    wishlistCount,
    videoCallTahItemsCount,
    maxVideoCallCount,
    maxCartItemsCount,
    videoCallCartMessage,
    accountMergingPopupEnabled,
    primaryAccountSet,
    phoneNumberVerified,
    hasPhoneNumber,
    pincode,
    guessedPincode,
  }: {
    isLoggedIn: boolean;
    isSoftLoggedIn?: boolean;
    softLoginId?: string;
    softLoginType?: string;
    userName?: string;
    visitorId?: number;
    cartCount: number;
    wishlistCount: number;
    videoCallTahItemsCount?: number;
    maxVideoCallCount?: number;
    maxCartItemsCount?: number;
    videoCallCartMessage?: string;
    accountMergingPopupEnabled?: boolean;
    primaryAccountSet?: boolean;
    phoneNumberVerified?: boolean;
    hasPhoneNumber?: boolean;
    pincode?: string;
    guessedPincode?: boolean;
  }) {
    this.isLoggedIn = isLoggedIn;
    this.isSoftLoggedIn = isSoftLoggedIn;
    this.softLoginId = softLoginId;
    this.softLoginType = softLoginType;
    this.userName = userName;
    this.visitorId = visitorId;
    this.customerName = userName;
    this.cartCount = cartCount;
    this.wishlistCount = wishlistCount;
    this.videoCallTahItemsCount = videoCallTahItemsCount ?? 0;
    this.maxVideoCallCount = maxVideoCallCount ?? 5;
    this.maxCartItemsCount = maxCartItemsCount ?? 30;
    this.videoCallCartMessage = videoCallCartMessage;
    this.accountMergingPopupEnabled = accountMergingPopupEnabled;
    this.primaryAccountSet = primaryAccountSet;
    this.phoneNumberVerified = phoneNumberVerified;
    this.hasPhoneNumber = hasPhoneNumber;
    this.pincode = pincode;
    this.guessedPincode = guessedPincode;
  }
}

